import { socketEmit, socketOff, socketOn } from 'lib/clients/socket';

import onAuthReq from './listeners/authReq/onAuthReq';
import onDataUpdate from './listeners/dataUpdate/onDataUpdate';
import onUserAuth from './listeners/userAuth/onUserAuth';
import onUserInit from './listeners/userInit/onUserInit';

export default (sessionToken = null, sessionClientId = null) => {
  try {
    socketEmit('user-init', { ok: true }, { reemitOnReconnect: true });

    socketOn('user-init', (response) => onUserInit(response, sessionToken, sessionClientId));
    socketOn('auth-req', () => onAuthReq());

    socketOn('user-auth', () => onUserAuth());

    socketOn('data-update', onDataUpdate);

    return () => {
      socketOff('user-auth', { sessionToken, sessionClientId });
    };
  } catch (error) {
    console.error(error);
  }
};
